(() => {
if (!document.querySelector('[data-cav-discovery]')) return;

class CavFilterDrawer extends MenuDrawer {
  bindEvents() {
    if (this.cavBound) return;
    this.cavBound = true;
    this.addEventListener('click', (event) => {
      const close = event.target.closest('[data-cav-close-drawer], [data-cav-view-results]');
      if (close) {
        event.preventDefault();
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
        return;
      }
      const summary = event.target.closest('summary');
      if (summary && this.contains(summary)) {
        this.onSummaryClick({ currentTarget: summary, preventDefault: () => event.preventDefault() });
        return;
      }
      const back = event.target.closest('.mobile-facets__close-button');
      if (back) this.closeSubmenu(back.closest('details'));
    });
  }

  onSummaryClick(event) {
    const summary = event.currentTarget;
    if (summary.parentElement !== this.mainDetailsToggle) {
      super.onSummaryClick(event);
      return;
    }
    event.preventDefault();
    if (this.mainDetailsToggle.open) {
      this.closeMenuDrawer(event, summary);
    } else {
      this.mainDetailsToggle.open = true;
      this.openMenuDrawer(summary);
    }
  }

  openMenuDrawer(summaryElement) {
    super.openMenuDrawer(summaryElement);
    this.mainDetailsToggle.classList.add('menu-opening');
    this.inertSiblings = [];
    let branch = this;
    while (branch.parentElement) {
      [...branch.parentElement.children].forEach((sibling) => {
        if (sibling !== branch && !sibling.inert && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
          sibling.inert = true;
          this.inertSiblings.push(sibling);
        }
      });
      if (branch.parentElement === document.body) break;
      branch = branch.parentElement;
    }
    requestAnimationFrame(() => this.refreshFocus(true));
  }

  refreshFocus(force = false) {
    if (!this.mainDetailsToggle.open) return;
    const inner = this.querySelector('[role="dialog"]');
    const activeSubmenu = this.querySelector('.mobile-facets__details[open] .mobile-facets__submenu');
    const scope = activeSubmenu || inner;
    if (force || !scope.contains(document.activeElement)) {
      trapFocus(scope, scope.querySelector('button') || this.querySelector('[data-cav-close-drawer]'));
    } else {
      trapFocus(scope, document.activeElement);
    }
  }

  closeMenuDrawer(event, elementToFocus) {
    this.inertSiblings?.forEach((sibling) => { sibling.inert = false; });
    this.inertSiblings = [];
    const trigger = elementToFocus || this.mainDetailsToggle.querySelector('summary');
    super.closeMenuDrawer(event, trigger);
    trigger.setAttribute('aria-expanded', 'false');
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE' && this.mainDetailsToggle.open) {
      event.preventDefault();
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
    }
  }

  onFocusOut() {}
}
customElements.define('cav-filter-drawer', CavFilterDrawer);
class CavFacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = (event) => {
      CavFacetFiltersForm.cancelPending();
      this.submitTimer = setTimeout(() => this.onSubmitHandler(event), 300);
    };

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      this.debouncedOnSubmit(event);
    });
    facetForm.addEventListener('submit', (event) => this.onSubmitHandler(event));
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cav-category-toggle]');
      if (!button) return;
      const children = document.getElementById(button.getAttribute('aria-controls'));
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      children.hidden = !expanded;
      button.firstElementChild.textContent = expanded ? '−' : '+';
    });
    CavFacetFiltersForm.initializeCategoryTrees(this);

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static initializeCategoryTrees(root = document) {
    root.querySelectorAll('[data-cav-category-toggle]').forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const node = button.closest('[data-cav-category-node]');
      const children = document.getElementById(button.getAttribute('aria-controls'));
      const expanded = Boolean(node.querySelector('input:checked'));
      button.setAttribute('aria-expanded', String(expanded));
      button.firstElementChild.textContent = expanded ? '−' : '+';
      children.hidden = !expanded;
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = window.location.search.slice(1);
      if (searchParams === CavFacetFiltersForm.searchParamsPrev) return;
      CavFacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    document.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-cav-category-chip]');
      if (!chip || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const target = new URL(chip.href, window.location.href);
      if (target.origin !== window.location.origin || target.pathname !== window.location.pathname) return;
      event.preventDefault();
      const current = new URLSearchParams(window.location.search);
      if (current.has('view')) target.searchParams.set('view', current.get('view'));
      target.searchParams.delete('page');
      CavFacetFiltersForm.renderPage(target.searchParams.toString(), event);
    });
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static context() {
    return document.querySelector('[data-cav-discovery]');
  }

  static normalize(searchParams) {
    const params = new URLSearchParams(searchParams);
    if (!window.location.search.includes('view=')) params.delete('view');
    params.delete('section_id');
    params.sort();
    return params.toString();
  }

  static cancelPending() {
    document.querySelectorAll('facet-filters-form').forEach((form) => clearTimeout(form.submitTimer));
    CavFacetFiltersForm.controller?.abort();
    CavFacetFiltersForm.requestId = (CavFacetFiltersForm.requestId || 0) + 1;
  }

  static busy(value) {
    const root = CavFacetFiltersForm.context();
    root.setAttribute('aria-busy', String(value));
    document.getElementById('ProductGridContainer').setAttribute('aria-busy', String(value));
    root.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.toggle('hidden', !value));
    root.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((count) => count.classList.toggle('loading', value));
    root.querySelector('#ProductGridContainer .collection')?.classList.toggle('loading', value);
    document.getElementById('CavDiscoveryStatus').textContent = value ? root.dataset.loading : '';
  }

  static async renderPage(searchParams, event, updateURLHash = true) {
    const chipFallback = event?.target?.closest('[data-cav-category-chip]')?.href;
    CavFacetFiltersForm.cancelPending();
    const requestId = CavFacetFiltersForm.requestId;
    searchParams = CavFacetFiltersForm.normalize(searchParams);
    CavFacetFiltersForm.searchParamsPrev = searchParams;
    const section = CavFacetFiltersForm.getSections()[0];
    const url = `${window.location.pathname}?section_id=${encodeURIComponent(section.section)}&${searchParams}`;
    CavFacetFiltersForm.busy(true);
    document.getElementById('CavDiscoveryError').hidden = true;
    if (updateURLHash) CavFacetFiltersForm.updateURLHash(searchParams);
    try {
      let html = CavFacetFiltersForm.filterData.find((entry) => entry.url === url)?.html;
      if (!html) {
        CavFacetFiltersForm.controller = new AbortController();
        const response = await fetch(url, { signal: CavFacetFiltersForm.controller.signal });
        if (!response.ok) throw new Error('Collection section request failed');
        html = await response.text();
      }
      if (requestId !== CavFacetFiltersForm.requestId) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (!parsed.getElementById('ProductGridContainer') || !parsed.getElementById('ProductCount')) {
        throw new Error('Collection section response is incomplete');
      }
      JSON.parse(parsed.getElementById('CavCollectionSchema').textContent);
      const focusId = document.activeElement?.id;
      const expandedCategoryIds = [...document.querySelectorAll('[data-cav-category-toggle][aria-expanded="true"]')].map((button) => button.getAttribute('aria-controls'));
      const drawer = document.querySelector('cav-filter-drawer');
      const wasOpen = drawer?.mainDetailsToggle.open;
      CavFacetFiltersForm.renderFilters(html, event);
      CavFacetFiltersForm.initializeCategoryTrees();
      expandedCategoryIds.forEach((id) => {
        const children = document.getElementById(id);
        const button = children?.parentElement.querySelector('[data-cav-category-toggle]');
        if (button) { children.hidden = false; button.setAttribute('aria-expanded', 'true'); button.firstElementChild.textContent = '−'; }
      });
      CavFacetFiltersForm.renderProductGridContainer(html);
      CavFacetFiltersForm.renderProductCount(html);
      CavFacetFiltersForm.renderCategoryChips(parsed);
      const canonical = parsed.querySelector('[data-cav-discovery]').dataset.canonical;
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonical && canonicalLink) canonicalLink.href = canonical;
      CavFacetFiltersForm.context().dataset.canonical = canonical;
      CavFacetFiltersForm.busy(false);
      document.getElementById('CavDiscoveryStatus').textContent = parsed.getElementById('ProductCount').textContent.trim();
      CavFacetFiltersForm.lastCommittedParams = searchParams;
      CavFacetFiltersForm.lastCommittedHTML = html;
      if (!CavFacetFiltersForm.filterData.some((entry) => entry.url === url)) {
        CavFacetFiltersForm.filterData = [...CavFacetFiltersForm.filterData.slice(-19), { html, url }];
      }
      if (focusId && document.getElementById(focusId)) {
        document.getElementById(focusId).focus({ preventScroll: true });
      } else if (wasOpen) {
        drawer.refreshFocus();
      } else if (event?.type === 'click') {
        document.getElementById('verticalTitle')?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (error.name === 'AbortError' || requestId !== CavFacetFiltersForm.requestId) return;
      const previous = CavFacetFiltersForm.lastCommittedParams;
      history.replaceState({ searchParams: previous }, '', window.location.pathname + (previous ? '?' + previous : ''));
      CavFacetFiltersForm.searchParamsPrev = previous;
      if (CavFacetFiltersForm.lastCommittedHTML) {
        CavFacetFiltersForm.renderFilters(CavFacetFiltersForm.lastCommittedHTML, null);
        CavFacetFiltersForm.renderCategoryChips(new DOMParser().parseFromString(CavFacetFiltersForm.lastCommittedHTML, 'text/html'));
      }
      CavFacetFiltersForm.busy(false);
      CavFacetFiltersForm.toggleActiveFacets(false);
      const message = document.getElementById('CavDiscoveryError');
      message.textContent = CavFacetFiltersForm.context().dataset.error;
      message.hidden = false;
      if (chipFallback) window.location.assign(chipFallback);
    }
  }

  static renderCategoryChips(parsed) {
    const current = document.getElementById('CavCategoryChips');
    const next = parsed.getElementById('CavCategoryChips');
    if (!current || !next) return;
    const scroll = current.querySelector('.cav-category-chips__list')?.scrollLeft || 0;
    current.innerHTML = next.innerHTML;
    const list = current.querySelector('.cav-category-chips__list');
    if (list) list.scrollLeft = scroll;
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      if (jsFilter?.hasAttribute('data-cav-category-filter')) return false;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const wrapper = document.getElementById(elementToRender.parentElement.id);
          if (wrapper) wrapper.append(elementToRender);
        }
      }
    });

    CavFacetFiltersForm.renderActiveFacets(parsedHTML);
    CavFacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        CavFacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        CavFacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    CavFacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('cav-filter-drawer')?.refreshFocus();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
      const sourceLink = source.querySelector('.mobile-facets__clear');
      const targetLink = target.querySelector('.mobile-facets__clear');
      if (sourceLink && targetLink) targetLink.href = sourceLink.href;
    }
  }

  static updateURLHash(searchParams) {
    if (searchParams === window.location.search.slice(1)) return;
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    params.delete('page');
    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    CavFacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sourceForm = event.target.closest('form');
    const mobile = sourceForm.id === 'FacetFiltersFormMobile';
    const facetForm = document.getElementById(mobile ? 'FacetFiltersFormMobile' : 'FacetFiltersForm');
    const params = new URLSearchParams(new FormData(facetForm));
    const sort = sourceForm.querySelector('[name="sort_by"]') ||
      document.getElementById(mobile ? 'SortBy-mobile' : 'SortBy');
    if (sort) params.set('sort_by', sort.value);
    params.delete('page');
    const unique = new URLSearchParams();
    for (const [name, value] of params) {
      if (!unique.getAll(name).includes(value)) unique.append(name, value);
    }
    this.onSubmitForm(unique.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    CavFacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const params = new URLSearchParams(url);
    const sort = document.getElementById('SortBy')?.value || document.getElementById('SortBy-mobile')?.value;
    if (!params.has('sort_by') && sort) params.set('sort_by', sort);
    params.delete('page');
    CavFacetFiltersForm.renderPage(params.toString(), event);
  }
}

CavFacetFiltersForm.filterData = [];
CavFacetFiltersForm.lastCommittedParams = window.location.search.slice(1);
CavFacetFiltersForm.lastCommittedHTML = document.querySelector('[data-cav-discovery]').outerHTML;
CavFacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
CavFacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', CavFacetFiltersForm);
CavFacetFiltersForm.setListeners();

class CavFacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', CavFacetRemove);

})();



